module.exports = __webpack_public_path__ + "img/part3-rightImg.386401cd.png";